const LETTER = "A-Za-zÀ-ÖØ-öø-ÿ"
const NAME_RE = new RegExp(`^[${LETTER}](?:[${LETTER}' -]*[${LETTER}])?$`)

export function validateName(value: string, label: string): string | null {
  const v = value.trim()
  if (!v) return `Fyll i ditt ${label}.`
  if (v.length < 2) return `${capitalize(label)} måste vara minst 2 bokstäver.`
  if (v.length > 40) return `${capitalize(label)} är för långt.`
  if (/\d/.test(v)) return `${capitalize(label)} kan inte innehålla siffror.`
  if (!NAME_RE.test(v)) return `Använd bara bokstäver i ${label}.`
  if (/(.)\1{2,}/i.test(v)) return `Kontrollera att ${label} är rätt stavat.`
  return null
}

const EMAIL_RE = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
const DOMAIN_TYPOS: Record<string, string> = {
  'gmail.con': 'gmail.com',
  'gmail.co': 'gmail.com',
  'gmail.se': 'gmail.com',
  'gmial.com': 'gmail.com',
  'gmai.com': 'gmail.com',
  'gnail.com': 'gmail.com',
  'hotmail.con': 'hotmail.com',
  'hotmal.com': 'hotmail.com',
  'hotmial.com': 'hotmail.com',
  'outlook.con': 'outlook.com',
  'icloud.con': 'icloud.com',
  'live.con': 'live.com',
  'yahoo.con': 'yahoo.com',
}

export function validateEmail(value: string): string | null {
  const v = value.trim()
  if (!v) return 'Fyll i din e-postadress.'
  if (!EMAIL_RE.test(v) || v.includes('..'))
    return 'Ange en giltig e-postadress, t.ex. namn@exempel.se.'
  const domain = v.split('@')[1].toLowerCase()
  const fix = DOMAIN_TYPOS[domain]
  if (fix) return `Menade du ${v.split('@')[0]}@${fix}?`
  return null
}

/** Normalises to digits, converting +46 / 0046 to a leading 0. */
function normalisePhone(value: string): string {
  let v = value.replace(/[\s\-().]/g, '')
  if (v.startsWith('+46')) v = '0' + v.slice(3)
  else if (v.startsWith('0046')) v = '0' + v.slice(4)
  return v.replace(/^00?0+/, '0')
}

export function validatePhone(value: string): string | null {
  const raw = value.trim()
  if (!raw) return 'Fyll i ditt telefonnummer.'
  if (/[^\d\s\-+().]/.test(raw))
    return 'Telefonnumret får bara innehålla siffror.'
  const compact = raw.replace(/[\s\-().]/g, '')
  // Foreign numbers: +XX followed by 7–14 digits
  if (/^\+(?!46)\d{8,15}$/.test(compact)) return null
  const v = normalisePhone(raw)
  if (/^07[02369]\d{7}$/.test(v)) return null // Svenskt mobilnummer
  if (/^0[1-9]\d{6,8}$/.test(v) && !v.startsWith('07')) return null // Fast telefon
  if (v.startsWith('07')) return 'Ett mobilnummer har 10 siffror, t.ex. 070-123 45 67.'
  return 'Ange ett giltigt telefonnummer, t.ex. 070-123 45 67.'
}

/** Pretty Swedish format for emails, e.g. 070-123 45 67 */
export function formatPhone(value: string): string {
  const v = normalisePhone(value.trim())
  const m = v.match(/^(07\d)(\d{3})(\d{2})(\d{2})$/)
  return m ? `${m[1]}-${m[2]} ${m[3]} ${m[4]}` : value.trim()
}

function capitalize(s: string): string {
  return s.charAt(0).toUpperCase() + s.slice(1)
}
